import { Component } from 'preact';
import { POPOVER_STYLE, GOLD, ACCENT_GOLD, TEXT_BODY } from '../../lib/medievalTheme';
import { pushDismiss, removeDismiss } from '../../utils/escStack';
import { t } from '../../localization/t';

/**
 * Floating ± preview chip that appears when the user scroll-wheels
 * over the HP / mana area of a player HUD. Position is computed in
 * canvas-local space (caller provides anchorRect. The HUD row's
 * getBoundingClientRect. And the canvas-local left/top is applied
 * here as inline style).
 */
export class HudScrollAdjuster extends Component {
  componentDidMount() {
    this._escDismissId = pushDismiss(() => this.props.onCancel?.());
    window.addEventListener('contextmenu', this._onContextMenu, true);
  }

  componentWillUnmount() {
    removeDismiss(this._escDismissId);
    window.removeEventListener('contextmenu', this._onContextMenu, true);
  }

  _onContextMenu = (e) => {
    e.preventDefault();
    this.props.onCancel?.();
  };

  render({ kind, delta, canvasLocalPos, anchorHeight }) {
    if (!canvasLocalPos) return null;
    const sign = delta > 0 ? `+${delta}` : `${delta}`;
    const isPositive = delta > 0;
    const valueColor = isPositive ? '#7ec8ff' : '#ff8a78';
    const kindLabel = kind === 'life' ? t('HP') : t('Mana');
    // Caller now passes the rect's top-left; we vertical-center the
    // chip on the row by adding half its height.
    const verticalCenter = canvasLocalPos.top + (anchorHeight ? anchorHeight / 2 : 0);
    return (
      <div
        className="pointer-events-none"
        style={{
          position: 'fixed',
          left: `${canvasLocalPos.left}px`,
          top: `${verticalCenter}px`,
          transform: 'translate(-100%, -50%)',
          marginLeft: '-0.5cqw',
          zIndex: 60,
          ...POPOVER_STYLE,
          background: 'rgba(12, 10, 8, 0.92)',
          border: `1px solid ${GOLD} 0.4)`,
          borderRadius: 'var(--radius-lg)',
          padding: '0.5cqw 0.75cqw',
          minWidth: '5cqw',
          textAlign: 'center',
          boxShadow: '0 8px 22px rgba(0,0,0,0.55)',
        }}
        aria-live="polite"
      >
        <div
          className="arena-heading"
          style={{
            color: valueColor,
            fontSize: '1.6cqw',
            lineHeight: 1,
            fontWeight: 800,
            letterSpacing: '0.02em',
          }}
        >
          {sign}
        </div>
        <div
          style={{
            color: ACCENT_GOLD,
            fontSize: '0.55cqw',
            marginTop: '0.2cqw',
            fontWeight: 700,
          }}
        >
          {kindLabel}
        </div>
        {kind === 'mana' ? (
          <div style={{ color: TEXT_BODY, fontSize: '0.5cqw', marginTop: '0.15cqw' }}>
            {t('as: this turn')}
          </div>
        ) : null}
        <div
          style={{
            color: TEXT_BODY,
            fontSize: '0.5cqw',
            marginTop: '0.3cqw',
            opacity: 0.75,
            whiteSpace: 'nowrap',
          }}
        >
          {t('Click to apply · ESC to cancel')}
        </div>
      </div>
    );
  }
}
